
import Vue from "vue";
import {
  maxLengthRule,
  minLengthRule,
  requiredRule
} from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Create",

  data: () => ({
    maxLengthRule,
    minLengthRule,
    requiredRule,
    model: {} as any,
    errorMessages: {} as { [value: string]: Array<string> }
  }),

  computed: {
    computedRules(): object {
      return {
        min: this.minLengthRule.bind(this),
        max: this.maxLengthRule.bind(this),
        required: this.requiredRule.bind(this)
      };
    }
  },

  methods: {
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as Vue).validate()) {
          const model = { ...this.model };

          await this.$API.workPositions().create(model);
          await this.$router.push("/work-positions");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global_alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;

          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    }
  }
});
